import React from 'react';
import {InputTextarea} from "primereact/inputtextarea";
import AdminFieldLabel from './AdminFieldLabel';

interface AdminTextAreaProps {
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  required?: boolean;
  name: string;
  id: string;
  className?: string;
  error?: string;
}

const AdminTextArea: React.FC<AdminTextAreaProps> = ({
  label,
  value,
  onChange,
  placeholder,
  rows = 4,
  required = false,
  name,
  id,
                                                       className = '',
                                                       error
}) => {
  return (
    <div className={className}>
      {label && <AdminFieldLabel htmlFor={id} label={label} required={required}/>}
      <InputTextarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        required={required}
        className={`w-full px-4 py-3 border rounded-sm focus:outline-none focus:border-gray-500 ${error ? 'border-red-500' : 'border-gray-300'}`}
      />
      {error && <small className="block text-red-500 text-xs mt-1">{error}</small>}
    </div>
  );
};

export default AdminTextArea;
